import { request, METHOD } from '@/utils/request'
import { BASE_URL } from '@/config/public'

export async function rqtPostUserLoginInfo(params) {
  return request(
    `${BASE_URL}/provider/ams/userPrivilege/getmenu?UUID_KEY=${params.uuid_key}`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtGetRefreshToken(params) {
  return request(`${BASE_URL}/provider/token/refresh`, METHOD.GET, params)
}

export async function rqtGetUserWorkwechatLogin(params) {
  return request(
    `${BASE_URL}/provider/ams/userPrivilege/workwechat/login`,
    METHOD.GET,
    params
  )
}

export async function rqtGetUserCheckToken(params) {
  return request(`${BASE_URL}/provider/token/accesstoken`, METHOD.GET, params)
}

export async function rqtPostWechatLogin(params) {
  return request(
    `${BASE_URL}/provider/ams/userPrivilege/wechat/login/?code=${params.code}`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtGetUserWechatLoginMobileSms(params) {
  return request(
    `${BASE_URL}/provider/ams/userPrivilege/wechat/login/mobile/sms`,
    METHOD.GET,
    params
  )
}

export async function rqtPostUserWechatLoginMobile(params) {
  return request(
    `${BASE_URL}/provider/ams/userPrivilege/wechat/login/mobile`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtPostUserPrivilegeVerify(params) {
  return await request(
    `${BASE_URL}/provider/ams/userPrivilege/wechat/login/verify/password`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtPostUserPrivilegeSave(params) {
  return await request(
    `${BASE_URL}/provider/ams/userPrivilege/wechat/login/save/password`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtPostUserPrivilegeWechatLogout(params) {
  return await request(
    `${BASE_URL}/provider/ams/userPrivilege/wechat/login/logout`,
    METHOD.GET,
    params
  )
}

export async function rqtGetCheckCodeImg(params) {
  return request(
    `${BASE_URL}/provider/Kaptcha.jpg?${Math.floor(Math.random() * 100)}`,
    METHOD.GET,
    params,
    { responseType: 'blob' }
  )
}

export async function rqtGetCheckCodeImgForAppointment(params) {
  return request(
    `${BASE_URL}/provider/${params.productId}/${params.openDate}/Kaptcha.jpg?${Math.floor(Math.random() * 100)}`,
    METHOD.GET,
    params, 
    { responseType: 'blob' } 
  )
}

//修改邮箱 请求验证码
export async function rqtGetUserWechatUpdateEmailSms(params) {
  return request(
    `${BASE_URL}/provider/ams/userPrivilege/wechat/updateEmail/mobile/sms`,
    METHOD.GET,
    params
  )
}
//修改邮箱验证验证码
export async function rqtGetUserWechatCheckEmailSms(params) {
  return await request(
    `${BASE_URL}/provider/ams/userPrivilege/wechat/check/mobile/sms`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}